function createKeyEnum(data) {
  return {
    ...data,

    getByKey(key) {
      let dataKeys = {};
      Object.entries(data).forEach( ([entryKey, { key }]) => {
        dataKeys[key] = this[entryKey];
      })
      return dataKeys[key];
    },

    getValues() {
      return Object.values(data);
    },
  }
}

const StatusData = Object.freeze({
  // please use material color ONLY here because color uses as class
  PUBLISHED: { key: 'Published', title: 'Published', color: 'success',          colorText: 'success--text',                icon: '$vuetify.icons.published' },
  EDITING:   { key: 'Editing',   title: 'Editing',   color: 'warning darken-1', colorText: 'warning--text text--darken-1', icon: '$vuetify.icons.editing' },
  REVIEW:    { key: 'Review',    title: 'Review',    color: 'blue lighten-1',   colorText: 'blue--text text--lighten-1',   icon: '$vuetify.icons.review' },
  REJECTED:  { key: 'Rejected',  title: 'Rejected',  color: 'error',            colorText: 'error--text',                  icon: '$vuetify.icons.rejected' },
});

const MaterialTypeData = Object.freeze({
  STATIC:     { key: 'Static',     title: 'Static' },
  PARAMETRIC: { key: 'Parametric', title: 'Parametric' },
});

const StatusCollectionData = Object.freeze({
  PUBLIC:  { key: 'Public',  title: 'Public' },
  PRIVATE: { key: 'Private', title: 'Private' },
});

const StatusComplaintData = Object.freeze({
  NEW:      { key: 'New',      title: 'New',      color: 'primary',      colorText: 'primary--text',      icon: '$vuetify.icons.complaintNew' },
  ACCEPTED: { key: 'Accepted', title: 'Accepted', color: 'success',      colorText: 'success--text',      icon: '$vuetify.icons.complaintAccepted' },
  REJECTED: { key: 'Rejected', title: 'Rejected', color: 'subsecondary', colorText: 'subsecondary--text', icon: '$vuetify.icons.complaintRejected' },
});

const PackageStatusData = Object.freeze({
  UPLOADED:   { key: 'Uploaded',   title: 'Uploaded',  color: 'subsecondary', colorText: 'subsecondary--text', icon: 'mdi-upload' },
  VALIDATION: { key: 'Validation', tile: 'Validation', color: 'white',        colorText: 'white--text',        icon: 'mdi-sync mdi-spin' },
  VERIFIED:   { key: 'Verified',   title: 'Verified',  color: 'green',        colorText: 'green--text',        icon: 'mdi-check' },
  INVALID:    { key: 'Invalid',    title: 'Invalid',   color: 'primary',      colorText: 'primary--text',      icon: 'mdi-window-close' },
});

const Status = Object.freeze(createKeyEnum(StatusData));
const MaterialType = Object.freeze(createKeyEnum(MaterialTypeData));
const StatusCollection = Object.freeze(createKeyEnum(StatusCollectionData));
const StatusComplaint = Object.freeze(createKeyEnum(StatusComplaintData));
const PackageStatus = Object.freeze(createKeyEnum(PackageStatusData));

const Roles = Object.freeze({
  ADMIN: 'admin',
  MODERATOR: 'moderator',
});

const Entity = Object.freeze({
  ACCOUNT: 'Account',
  PASSWORD: 'Password',
  CATEGORY: 'Category',
  COLLECTION: 'Collection',
  COMMENT: 'Comment',
  COMPLAINT: 'Complaint',
  MANAGEMENT: 'Management',
  MATERIAL: 'Material',
  RENDER: 'Render',
  TAG: 'Tag',
  PACKAGE: 'Package',
});

export default {
	Status,
  Roles,
  StatusCollection,
  StatusComplaint,
  MaterialType,
  Entity,
  PackageStatus,
};
